(() => {
  const html = document.documentElement;
  const body = document.body;

  html.classList.remove("no-js");
  html.classList.add("js");

  /* Shopify dev-store protection: remove body[hidden] that content_for_header injects */
  if (body.hidden) {
    body.hidden = false;
    body.style.display = "";
  }

  const currency = window.theme?.moneyCurrency || "PLN";
  const drawerSelector = "[data-drawer]";

  const formatMoney = (value) => {
    const amount = Number(value) / 100;

    try {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency
      }).format(amount);
    } catch (_error) {
      return `${amount.toFixed(2)} ${currency}`;
    }
  };

  const showToast = (message) => {
    const toast = document.querySelector("[data-theme-toast]");

    if (!toast) return;

    toast.textContent = message;
    toast.classList.add("is-visible");

    window.clearTimeout(showToast.timeoutId);
    showToast.timeoutId = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 2400);
  };

  const createRippleEffect = (button, clientX, clientY) => {
    const ripple = document.createElement("span");
    const isLauncherButton = button.matches(".launcher-tile, .launcher-dock__item, .launcher-legal__button");
    const host =
      button.matches(".launcher-tile")
        ? button.querySelector(".launcher-tile__icon") || button
        : button;
    const rect = host.getBoundingClientRect();
    const size = isLauncherButton
      ? Math.max(rect.width, rect.height) * 0.42
      : Math.max(rect.width, rect.height);

    ripple.className = isLauncherButton
      ? "ripple__effect ripple__effect--water"
      : "ripple__effect";
    ripple.style.width = `${size}px`;
    ripple.style.height = `${size}px`;
    ripple.style.left = `${clientX - rect.left}px`;
    ripple.style.top = `${clientY - rect.top}px`;
    host.appendChild(ripple);

    window.setTimeout(() => ripple.remove(), isLauncherButton ? 980 : 650);
  };

  const setCartCount = (count) => {
    document.querySelectorAll("[data-cart-count]").forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count < 1;
    });
  };

  const closeAllDrawers = () => {
    document.querySelectorAll(drawerSelector).forEach((drawer) => {
      drawer.setAttribute("aria-hidden", "true");
    });

    const cartDrawer = document.querySelector("[data-cart-drawer]");

    if (cartDrawer) {
      cartDrawer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
    }

    body.classList.remove("drawer-open");
  };

  const openFilterDrawer = () => {
    const drawer = document.querySelector("[data-filter-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    body.classList.add("drawer-open");
  };

  const closeFilterDrawer = () => {
    const drawer = document.querySelector("[data-filter-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    body.classList.remove("drawer-open");
  };

  const openDrawer = (name) => {
    closeAllDrawers();

    const drawer = document.querySelector(`[data-drawer="${name}"]`);
    if (!drawer) return;

    drawer.setAttribute("aria-hidden", "false");
    body.classList.add("drawer-open");
  };

  const openCartDrawer = () => {
    closeAllDrawers();

    const cartDrawer = document.querySelector("[data-cart-drawer]");
    if (!cartDrawer) return;

    cartDrawer.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    body.classList.add("drawer-open");
  };

  const refreshCartDrawer = async (openAfterRefresh = false) => {
    const sectionWrapper = document.querySelector("#shopify-section-cart-drawer");

    if (!sectionWrapper) return;

    const [sectionResponse, cartResponse] = await Promise.all([
      fetch("/?section_id=cart-drawer"),
      fetch("/cart.js")
    ]);

    const sectionHtml = await sectionResponse.text();
    const cart = await cartResponse.json();
    const parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    const incoming = parsed.querySelector("#shopify-section-cart-drawer");

    if (incoming) {
      sectionWrapper.replaceWith(incoming);
    }

    setCartCount(cart.item_count);

    if (openAfterRefresh) {
      openCartDrawer();
    }
  };

  const updateProductSummary = (form) => {
    if (!form) return;

    const variantSelect = form.querySelector("[name='id']");
    const variantScript = form.querySelector("[data-product-variants]");

    if (!variantSelect || !variantScript) return;

    const variants = JSON.parse(variantScript.textContent);
    const selectedVariant = variants.find(
      (variant) => String(variant.id) === variantSelect.value
    );

    if (!selectedVariant) return;

    const section = form.closest("[data-product-section]");
    const submit = form.querySelector("[type='submit']");
    const priceElement = section?.querySelector("[data-product-price]");
    const compareElement = section?.querySelector("[data-product-compare-price]");
    const stickyPrice = section?.querySelector("[data-sticky-price]");
    const skuElement = section?.querySelector("[data-product-sku]");
    const mediaViewer = section?.querySelector("[data-product-main-image]");

    if (priceElement) {
      priceElement.textContent = formatMoney(selectedVariant.price);
    }

    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(selectedVariant.price);
    }

    if (compareElement) {
      if (selectedVariant.compare_at_price > selectedVariant.price) {
        compareElement.hidden = false;
        compareElement.textContent = formatMoney(selectedVariant.compare_at_price);
      } else {
        compareElement.hidden = true;
      }
    }

    if (skuElement) {
      skuElement.textContent = selectedVariant.sku || "Na zamówienie";
    }

    if (submit) {
      submit.disabled = !selectedVariant.available;
      submit.textContent = selectedVariant.available
        ? window.theme.strings.addToCart
        : window.theme.strings.soldOut;
    }

    if (mediaViewer && selectedVariant.featured_image?.src) {
      mediaViewer.src = selectedVariant.featured_image.src;
      mediaViewer.alt = selectedVariant.featured_image.alt || selectedVariant.name;
    }
  };

  const buildPredictiveSearchItem = (product) => {
    const item = document.createElement("a");
    item.className = "predictive-search__item";
    item.href = product.url || "/search";

    const media = document.createElement("div");
    media.className = "predictive-search__thumb card";

    if (product.image) {
      const image = document.createElement("img");
      image.src = product.image;
      image.alt = product.title || "";
      image.loading = "lazy";
      media.appendChild(image);
    }

    const content = document.createElement("div");
    const title = document.createElement("strong");
    title.textContent = product.title || "";

    content.appendChild(title);

    if (product.vendor) {
      const vendor = document.createElement("div");
      vendor.className = "section-copy";
      vendor.textContent = product.vendor;
      content.appendChild(vendor);
    }

    if (product.price) {
      const price = document.createElement("div");
      price.className = "chip";
      price.textContent = product.price;
      content.appendChild(price);
    }

    item.append(media, content);

    return item;
  };

  const renderPredictiveSearchMessage = (results, message) => {
    const paragraph = document.createElement("p");
    paragraph.className = "section-copy";
    paragraph.textContent = message;
    results.replaceChildren(paragraph);
  };

  const setupPredictiveSearch = () => {
    document.querySelectorAll("[data-predictive-search]").forEach((wrapper) => {
      const input = wrapper.querySelector("[data-predictive-search-input]");
      const results = wrapper.querySelector("[data-predictive-search-results]");

      if (!input || !results) return;

      let timeoutId;

      input.addEventListener("input", () => {
        window.clearTimeout(timeoutId);
        const query = input.value.trim();

        if (!query) {
          results.replaceChildren();
          return;
        }

        timeoutId = window.setTimeout(async () => {
          try {
            const response = await fetch(
              `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`
            );
            const payload = await response.json();
            const products = payload.resources?.results?.products || [];

            if (!products.length) {
              renderPredictiveSearchMessage(results, window.theme.strings.emptySearch);
              return;
            }

            results.replaceChildren(
              ...products.map((product) => buildPredictiveSearchItem(product))
            );

            results.querySelectorAll(".predictive-search__item").forEach((item) => {
              item.addEventListener("click", () => {
                closeAllDrawers();
              });
            });
          } catch (_error) {
            renderPredictiveSearchMessage(results, "Nie udało się pobrać wyników.");
          }
        }, 220);
      });
    });
  };

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest("[data-toggle-drawer]");
    const close = event.target.closest("[data-close-drawer]");
    const cartOpen = event.target.closest("[data-open-cart]");
    const cartClose = event.target.closest("[data-close-cart]");
    const stickySubmit = event.target.closest("[data-sticky-submit]");
    const thumb = event.target.closest("[data-product-thumb]");

    if (toggle) {
      event.preventDefault();
      openDrawer(toggle.dataset.toggleDrawer);
      return;
    }

    if (close) {
      event.preventDefault();
      closeAllDrawers();
      return;
    }

    if (cartOpen) {
      event.preventDefault();
      openCartDrawer();
      return;
    }

    if (cartClose) {
      event.preventDefault();
      closeAllDrawers();
      return;
    }

    if (stickySubmit) {
      event.preventDefault();

      const form = document.getElementById(stickySubmit.dataset.stickySubmit);
      if (form) {
        form.requestSubmit();
      }
      return;
    }

    if (thumb) {
      event.preventDefault();

      const section = thumb.closest("[data-product-section]");
      const target = section?.querySelector("[data-product-main-image]");

      if (!section || !target) return;

      section.querySelectorAll("[data-product-thumb]").forEach((button) => {
        button.classList.remove("is-active");
      });

      thumb.classList.add("is-active");
      target.src = thumb.dataset.imageSrc;
      target.alt = thumb.dataset.imageAlt || "";
      return;
    }

    if (event.target.closest("[data-open-filter]")) {
      event.preventDefault();
      openFilterDrawer();
      return;
    }

    if (event.target.closest("[data-close-filter]")) {
      event.preventDefault();
      closeFilterDrawer();
      return;
    }

    /* Intent search dialog — native <dialog> */
    if (event.target.closest("[data-open-intent-search]")) {
      event.preventDefault();
      const dialog = document.getElementById("intentDialog");
      if (dialog && !dialog.open) {
        dialog.showModal();
        dialog.querySelector("#intentSearchInput")?.focus();
      }
      return;
    }

    if (event.target.closest("[data-close-intent-search]")) {
      event.preventDefault();
      document.getElementById("intentDialog")?.close();
      return;
    }

  });

  document.addEventListener("pointerdown", (event) => {
    if (event.button !== undefined && event.button !== 0) return;

    const button = event.target.closest(".ripple");

    if (!button || button.getAttribute("aria-disabled") === "true") {
      return;
    }

    createRippleEffect(button, event.clientX, event.clientY);
  });

  document.addEventListener("change", (event) => {
    const autoSubmit = event.target.closest("[data-auto-submit]");
    const productForm = event.target.closest(".product-form");

    if (autoSubmit) {
      autoSubmit.requestSubmit();
    }

    if (productForm && event.target.name === "id") {
      updateProductSummary(productForm);
    }
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target;

    if (!form.classList.contains("js-product-form")) {
      return;
    }

    event.preventDefault();
    form.classList.add("is-loading");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        },
        body: new FormData(form)
      });

      if (!response.ok) {
        throw new Error("Cart request failed");
      }

      await response.json();
      await refreshCartDrawer(true);
      showToast(window.theme.strings.addedToCart);
    } catch (_error) {
      showToast("Nie udało się dodać produktu.");
    } finally {
      form.classList.remove("is-loading");
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeAllDrawers();
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    /* Safety net: ensure body is visible after full DOM parse */
    if (document.body.hidden) {
      document.body.hidden = false;
      document.body.style.display = "";
    }

    setCartCount(Number(document.body.dataset.cartCount || 0));
    setupPredictiveSearch();

    document.querySelectorAll(".product-form").forEach((form) => {
      updateProductSummary(form);
    });
  });

  window.themeCart = {
    refresh: refreshCartDrawer,
    open: openCartDrawer
  };

  const setupLauncherMotion = () => {
    const launcher = document.querySelector("[data-launcher]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!launcher || reduceMotion) return;
    if (launcher.dataset.motionBound === "true") return;

    launcher.dataset.motionBound = "true";

    const tiles = [...launcher.querySelectorAll("[data-launcher-tile]")];
    if (!tiles.length) return;

    const MAX_TILT = 18;
    const MAX_SHIFT = 18;
    const ACTIVE_SCALE = 1.095;
    const POINT_RADIUS = 300;
    let frameId = 0;
    let activePoint = null;
    const touchFeedbackTimers = new WeakMap();

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const isTouchInteraction = (event) =>
      event?.pointerType === "touch" ||
      event?.pointerType === "pen" ||
      window.matchMedia("(pointer: coarse)").matches;

    const clearTouchFeedback = (tile) => {
      const timerId = touchFeedbackTimers.get(tile);

      if (timerId) {
        window.clearTimeout(timerId);
        touchFeedbackTimers.delete(tile);
      }
    };

    const setTouchVisualState = (tile, state = "idle") => {
      tile.classList.toggle("is-touch-primed", state === "primed");
      tile.classList.toggle("is-touch-feedback", state === "feedback");
    };

    const resetTile = (tile) => {
      clearTouchFeedback(tile);
      setTouchVisualState(tile);
      tile.style.setProperty("--follow-x", "0px");
      tile.style.setProperty("--follow-y", "0px");
      tile.style.setProperty("--rotate-x", "0deg");
      tile.style.setProperty("--rotate-y", "0deg");
      tile.style.setProperty("--tile-scale", "1");
      tile.style.setProperty("--proximity", "0");
      tile.style.setProperty("--tile-pointer-x", "50%");
      tile.style.setProperty("--tile-pointer-y", "50%");
      tile.style.setProperty("--hover-lift", "0px");
      tile.style.setProperty("--hover-scale", "1");
      tile.style.setProperty("--hover-rotate-z", "0deg");
      tile.style.setProperty("--hover-glow", "0");
      tile.style.setProperty("--press-scale", "1");
      tile.style.setProperty("--press-depth", "0px");
      tile.style.setProperty("--press-glow", "0");
    };

    const resetLauncher = () => {
      activePoint = null;
      launcher.style.setProperty("--pointer-x", "50%");
      launcher.style.setProperty("--pointer-y", "42%");
      tiles.forEach(resetTile);
    };

    const renderLauncher = () => {
      frameId = 0;

      if (!activePoint) {
        resetLauncher();
        return;
      }

      const launcherRect = launcher.getBoundingClientRect();
      const pointerX = ((activePoint.x - launcherRect.left) / launcherRect.width) * 100;
      const pointerY = ((activePoint.y - launcherRect.top) / launcherRect.height) * 100;

      launcher.style.setProperty("--pointer-x", `${clamp(pointerX, 0, 100).toFixed(2)}%`);
      launcher.style.setProperty("--pointer-y", `${clamp(pointerY, 0, 100).toFixed(2)}%`);

      tiles.forEach((tile) => {
        const icon = tile.querySelector("[data-launcher-icon]");
        if (!icon) return;

        const rect = icon.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const distanceX = activePoint.x - centerX;
        const distanceY = activePoint.y - centerY;
        const distance = Math.hypot(distanceX, distanceY);
        const proximity = clamp(1 - distance / POINT_RADIUS, 0, 1);
        const normalizedX = clamp(distanceX / (POINT_RADIUS / 2), -1, 1);
        const normalizedY = clamp(distanceY / (POINT_RADIUS / 2), -1, 1);
        const pointerX = clamp((activePoint.x - rect.left) / rect.width, 0, 1);
        const pointerY = clamp((activePoint.y - rect.top) / rect.height, 0, 1);
        const followX = normalizedX * MAX_SHIFT * proximity;
        const followY = normalizedY * (MAX_SHIFT - 2) * proximity;
        const rotateY = normalizedX * MAX_TILT * proximity;
        const rotateX = -normalizedY * MAX_TILT * proximity;
        const scale = 1 + (ACTIVE_SCALE - 1) * proximity;

        tile.style.setProperty("--follow-x", `${followX.toFixed(2)}px`);
        tile.style.setProperty("--follow-y", `${followY.toFixed(2)}px`);
        tile.style.setProperty("--rotate-x", `${rotateX.toFixed(2)}deg`);
        tile.style.setProperty("--rotate-y", `${rotateY.toFixed(2)}deg`);
        tile.style.setProperty("--tile-scale", scale.toFixed(3));
        tile.style.setProperty("--proximity", proximity.toFixed(3));
        tile.style.setProperty("--tile-pointer-x", `${(pointerX * 100).toFixed(1)}%`);
        tile.style.setProperty("--tile-pointer-y", `${(pointerY * 100).toFixed(1)}%`);
      });
    };

    const queueRender = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(renderLauncher);
    };

    const updatePoint = (x, y) => {
      activePoint = { x, y };
      queueRender();
    };

    launcher.addEventListener("pointermove", (event) => {
      updatePoint(event.clientX, event.clientY);
    });

    launcher.addEventListener("pointerdown", (event) => {
      updatePoint(event.clientX, event.clientY);
    });

    launcher.addEventListener("pointerleave", () => {
      resetLauncher();
    });

    launcher.addEventListener("pointerup", () => {
      resetLauncher();
    });

    launcher.addEventListener("pointercancel", () => {
      resetLauncher();
    });

    launcher.addEventListener(
      "touchmove",
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        updatePoint(touch.clientX, touch.clientY);
      },
      { passive: true }
    );

    launcher.addEventListener("touchend", resetLauncher, { passive: true });
    launcher.addEventListener("touchcancel", resetLauncher, { passive: true });

    tiles.forEach((tile) => {
      tile.addEventListener("pointerenter", (event) => {
        updatePoint(event.clientX, event.clientY);
      });

      tile.addEventListener("pointermove", (event) => {
        updatePoint(event.clientX, event.clientY);
      });

      tile.addEventListener("pointerdown", (event) => {
        updatePoint(event.clientX, event.clientY);
        const touchMode = isTouchInteraction(event);

        if (touchMode) {
          clearTouchFeedback(tile);
          setTouchVisualState(tile, "primed");
        }
        tile.style.setProperty("--press-scale", touchMode ? "0.93" : "0.93");
        tile.style.setProperty("--press-depth", touchMode ? "-14px" : "-10px");
        tile.style.setProperty("--press-glow", touchMode ? "1.08" : "1");
      });

      tile.addEventListener("pointerup", (event) => {
        tile.style.setProperty("--press-scale", "1");
        tile.style.setProperty("--press-depth", "0px");
        tile.style.setProperty("--press-glow", "0");

        if (isTouchInteraction(event)) {
          clearTouchFeedback(tile);
          setTouchVisualState(tile, "feedback");

          const timerId = window.setTimeout(() => {
            setTouchVisualState(tile);
            touchFeedbackTimers.delete(tile);
          }, 360);

          touchFeedbackTimers.set(tile, timerId);
          return;
        }

        setTouchVisualState(tile);
      });

      tile.addEventListener("pointercancel", (event) => {
        tile.style.setProperty("--press-scale", "1");
        tile.style.setProperty("--press-depth", "0px");
        tile.style.setProperty("--press-glow", "0");

        if (isTouchInteraction(event)) {
          clearTouchFeedback(tile);
          setTouchVisualState(tile, "feedback");

          const timerId = window.setTimeout(() => {
            setTouchVisualState(tile);
            touchFeedbackTimers.delete(tile);
          }, 260);

          touchFeedbackTimers.set(tile, timerId);
          return;
        }

        setTouchVisualState(tile);
      });

      tile.addEventListener("pointerleave", (event) => {
        if (isTouchInteraction(event)) {
          return;
        }

        clearTouchFeedback(tile);
        setTouchVisualState(tile);
        tile.style.setProperty("--press-scale", "1");
        tile.style.setProperty("--press-depth", "0px");
        tile.style.setProperty("--press-glow", "0");
      });

      ["touchend", "touchcancel"].forEach((eventName) => {
        tile.addEventListener(eventName, () => {
          tile.style.setProperty("--press-scale", "1");
          tile.style.setProperty("--press-depth", "0px");
          tile.style.setProperty("--press-glow", "0");

          clearTouchFeedback(tile);
          setTouchVisualState(tile, "feedback");

          const timerId = window.setTimeout(() => {
            setTouchVisualState(tile);
            touchFeedbackTimers.delete(tile);
          }, 320);

          touchFeedbackTimers.set(tile, timerId);
        }, { passive: true });
      });
    });

    resetLauncher();
  };

  const setupLauncherReactiveButtons = () => {
    const launcher = document.querySelector("[data-launcher]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!launcher || reduceMotion) return;

    const buttons = [
      ...launcher.querySelectorAll(".launcher-dock__item"),
      ...launcher.querySelectorAll(".launcher-legal__button")
    ];

    if (!buttons.length) return;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    buttons.forEach((button) => {
      if (button.dataset.reactiveBound === "true") return;

      button.dataset.reactiveBound = "true";

      const maxTilt = button.classList.contains("launcher-legal__button") ? 6 : 8;
      const maxShift = button.classList.contains("launcher-legal__button") ? 6 : 8;
      const idleScale = button.classList.contains("launcher-legal__button") ? 1.02 : 1.028;

      const resetButton = () => {
        button.style.setProperty("--reactive-x", "0px");
        button.style.setProperty("--reactive-y", "0px");
        button.style.setProperty("--reactive-rotate-x", "0deg");
        button.style.setProperty("--reactive-rotate-y", "0deg");
        button.style.setProperty("--reactive-scale", "1");
        button.style.setProperty("--reactive-glow", "0");
        button.style.setProperty("--reactive-pointer-x", "50%");
        button.style.setProperty("--reactive-pointer-y", "50%");
      };

      const updateButton = (clientX, clientY, isPressed = false) => {
        const rect = button.getBoundingClientRect();
        const pointerX = clamp((clientX - rect.left) / rect.width, 0, 1);
        const pointerY = clamp((clientY - rect.top) / rect.height, 0, 1);
        const normalizedX = (pointerX - 0.5) * 2;
        const normalizedY = (pointerY - 0.5) * 2;
        const shiftX = normalizedX * maxShift;
        const shiftY = normalizedY * maxShift;
        const rotateY = normalizedX * maxTilt;
        const rotateX = -normalizedY * maxTilt;
        const scale = isPressed ? 0.955 : idleScale;

        button.style.setProperty("--reactive-x", `${shiftX.toFixed(2)}px`);
        button.style.setProperty("--reactive-y", `${shiftY.toFixed(2)}px`);
        button.style.setProperty("--reactive-rotate-x", `${rotateX.toFixed(2)}deg`);
        button.style.setProperty("--reactive-rotate-y", `${rotateY.toFixed(2)}deg`);
        button.style.setProperty("--reactive-scale", scale.toFixed(3));
        button.style.setProperty("--reactive-glow", isPressed ? "1" : "0.86");
        button.style.setProperty("--reactive-pointer-x", `${(pointerX * 100).toFixed(1)}%`);
        button.style.setProperty("--reactive-pointer-y", `${(pointerY * 100).toFixed(1)}%`);
      };

      button.addEventListener("pointermove", (event) => {
        updateButton(event.clientX, event.clientY, false);
      });

      button.addEventListener("pointerenter", (event) => {
        updateButton(event.clientX, event.clientY, false);
      });

      button.addEventListener("pointerdown", (event) => {
        updateButton(event.clientX, event.clientY, true);
      });

      ["pointerleave", "pointercancel", "pointerup"].forEach((eventName) => {
        button.addEventListener(eventName, resetButton);
      });

      button.addEventListener(
        "touchmove",
        (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          updateButton(touch.clientX, touch.clientY, false);
        },
        { passive: true }
      );

      ["touchend", "touchcancel"].forEach((eventName) => {
        button.addEventListener(eventName, resetButton, { passive: true });
      });

      resetButton();
    });
  };

  const setupLauncherScrollShadow = () => {
    const launcher = document.querySelector("[data-launcher]");

    if (!launcher) return;
    if (launcher.dataset.scrollShadowBound === "true") return;

    launcher.dataset.scrollShadowBound = "true";

    let frameId = 0;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const applyShadowState = () => {
      frameId = 0;

      const maxTravel = clamp(window.innerHeight * 0.78, 240, 520);
      const scrollRange = Math.max(
        document.documentElement.scrollHeight - window.innerHeight,
        1
      );
      const effectiveTravel = Math.min(maxTravel, scrollRange);
      const progress = clamp(window.scrollY / effectiveTravel, 0, 1);
      const blur = 34 - (progress * 18);
      const shadowY = 1.7 - (progress * 1.2);
      const shadowScale = 1 - (progress * 0.28);
      const shadowOpacity = 1 - (progress * 0.44);
      const platformOpacity = 1 - (progress * 0.72);
      const ambientOpacity = 1 - (progress * 0.5);

      launcher.style.setProperty("--scroll-depth", progress.toFixed(3));
      launcher.style.setProperty("--scroll-shadow-blur", `${blur.toFixed(2)}px`);
      launcher.style.setProperty("--scroll-shadow-y", `${shadowY.toFixed(2)}rem`);
      launcher.style.setProperty("--scroll-shadow-scale", shadowScale.toFixed(3));
      launcher.style.setProperty("--scroll-shadow-opacity", shadowOpacity.toFixed(3));
      launcher.style.setProperty("--scroll-platform-opacity-multiplier", platformOpacity.toFixed(3));
      launcher.style.setProperty("--scroll-ambient-opacity", ambientOpacity.toFixed(3));
    };

    const queueShadowState = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(applyShadowState);
    };

    window.addEventListener("scroll", queueShadowState, { passive: true });
    window.addEventListener("resize", queueShadowState, { passive: true });

    applyShadowState();
  };

  const setupLauncherHeroLens = () => {
    const launcher = document.querySelector("[data-launcher]");
    const hero = launcher?.querySelector("[data-launcher-hero]");
    const heading = hero?.querySelector("[data-launcher-hero-heading]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (!hero || !heading || reduceMotion) return;
    if (hero.dataset.lensBound === "true") return;

    hero.dataset.lensBound = "true";

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const resetLens = () => {
      hero.style.setProperty("--hero-pointer-x", "50%");
      hero.style.setProperty("--hero-pointer-y", "46%");
      hero.style.setProperty("--hero-lens-opacity", "0");
      hero.style.setProperty("--hero-lens-scale", "1");
    };

    const updateLens = (clientX, clientY, isPressed = false) => {
      const rect = heading.getBoundingClientRect();
      const pointerX = clamp((clientX - rect.left) / rect.width, 0, 1);
      const pointerY = clamp((clientY - rect.top) / rect.height, 0, 1);

      hero.style.setProperty("--hero-pointer-x", `${(pointerX * 100).toFixed(1)}%`);
      hero.style.setProperty("--hero-pointer-y", `${(pointerY * 100).toFixed(1)}%`);
      hero.style.setProperty("--hero-lens-opacity", "1");
      hero.style.setProperty("--hero-lens-scale", isPressed ? "1.06" : "1.035");
    };

    heading.addEventListener("pointerenter", (event) => {
      updateLens(event.clientX, event.clientY, false);
    });

    heading.addEventListener("pointermove", (event) => {
      updateLens(event.clientX, event.clientY, false);
    });

    heading.addEventListener("pointerdown", (event) => {
      updateLens(event.clientX, event.clientY, true);
    });

    heading.addEventListener("pointerleave", resetLens);
    heading.addEventListener("pointercancel", resetLens);

    heading.addEventListener("pointerup", (event) => {
      updateLens(event.clientX, event.clientY, false);
    });

    heading.addEventListener(
      "touchmove",
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        updateLens(touch.clientX, touch.clientY, false);
      },
      { passive: true }
    );

    ["touchend", "touchcancel"].forEach((eventName) => {
      heading.addEventListener(eventName, resetLens, { passive: true });
    });

    resetLens();
  };

  const setupLauncherPolicies = () => {
    const legalNav = document.querySelector("[data-launcher-legal]");
    const legalPanel = legalNav?.closest("[data-launcher-legal-panel]");
    const legalToggle = legalPanel?.querySelector("[data-launcher-legal-toggle]");
    const mobileQuery = window.matchMedia("(max-width: 767px)");

    if (!legalNav) return;
    if (legalNav.dataset.policiesBound === "true") return;

    legalNav.dataset.policiesBound = "true";

    const setLegalPanelState = (open) => {
      if (!legalPanel || !legalToggle) return;

      legalPanel.classList.toggle("is-open", open);
      legalToggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    if (legalPanel && legalToggle) {
      setLegalPanelState(!mobileQuery.matches);

      if (legalPanel.dataset.toggleBound !== "true") {
        legalPanel.dataset.toggleBound = "true";

        legalToggle.addEventListener("click", () => {
          setLegalPanelState(!legalPanel.classList.contains("is-open"));
        });

        const handleViewportChange = (event) => {
          setLegalPanelState(!event.matches);
        };

        if (typeof mobileQuery.addEventListener === "function") {
          mobileQuery.addEventListener("change", handleViewportChange);
        } else if (typeof mobileQuery.addListener === "function") {
          mobileQuery.addListener(handleViewportChange);
        }
      }
    }

    const policyLinks = [...legalNav.querySelectorAll("[data-policy-link]")];

    if (!policyLinks.length) return;

    const setPolicyState = (link, available) => {
      link.classList.toggle("is-disabled", !available);
      link.setAttribute("aria-disabled", available ? "false" : "true");

      if (available) {
        link.removeAttribute("tabindex");
      } else {
        link.setAttribute("tabindex", "-1");
      }
    };

    policyLinks.forEach((link) => {
      const isDefaultAvailable = link.dataset.policyDefault === "available";

      setPolicyState(link, isDefaultAvailable);

      fetch(link.href, {
        credentials: "same-origin",
        redirect: "follow"
      })
        .then((response) => {
          const isPasswordPage = response.url.includes("/password");

          if (!response.ok || isPasswordPage) {
            setPolicyState(link, isDefaultAvailable);
            return;
          }

          setPolicyState(link, true);
        })
        .catch(() => {
          setPolicyState(link, isDefaultAvailable);
        });
    });
  };

  const applyServiceHomepageFallback = () => {
    const launcher = document.querySelector("[data-launcher]");

    if (!launcher || window.location.pathname !== "/") return;
    if (launcher.dataset.serviceSync === "true") return;

    launcher.dataset.serviceSync = "true";

    const tagline = launcher.querySelector(".launcher-tagline");
    const heading = launcher.querySelector(".launcher-heading");
    const copy = launcher.querySelector(".launcher-copy");
    const footer = launcher.querySelector(".launcher-footer");
    const tiles = [...launcher.querySelectorAll("[data-launcher-tile]")];
    const dockItems = [...launcher.querySelectorAll(".launcher-dock__item")];
    const tileConfig = [
      {
        label: "Projekty",
        href: "https://4vision.pl/en/projects-and-installations/",
        color: "#198cff"
      },
      {
        label: "Serwis",
        href: "/pages/serwis",
        color: "#ff9800"
      },
      {
        label: "Broadcast",
        href: "https://4vision.pl/en/broadcast/",
        color: "#00bcd4"
      },
      {
        label: "Studio",
        href: "https://4vision.pl/en/studio-equipment/",
        color: "#7c4dff"
      },
      {
        label: "Post",
        href: "https://4vision.pl/en/postproduction/",
        color: "#43a047"
      },
      {
        label: "Movie",
        href: "https://4vision.pl/en/movie/",
        color: "#e53935"
      }
    ];
    const dockConfig = [
      { label: "Realizacje", href: "/pages/realizacje" },
      { label: "Partnerzy", href: "/pages/partnerzy" },
      { label: "Kontakt", href: "/pages/kontakt" },
      { label: "Sklep", href: "/collections/all" }
    ];

    if (tagline) {
      tagline.textContent = "4VISION SERVICES";
    }

    if (heading) {
      heading.textContent = "Zacznij od usługi, której potrzebujesz.";
      heading.dataset.headingText = heading.textContent;
    }

    if (copy) {
      copy.textContent =
        "4Vision projektuje, wdraża i serwisuje workflow broadcast, studio, post i AV/IP.";
    }

    if (footer) {
      footer.textContent =
        "projects · service center · broadcast · studio · post-production · movie";
    }

    tiles.forEach((tile, index) => {
      const config = tileConfig[index];
      const label = tile.querySelector(".launcher-tile__label");

      if (!config || !label) return;

      tile.href = config.href;
      tile.style.setProperty("--tile-color", config.color);
      label.textContent = config.label;
    });

    dockItems.forEach((item, index) => {
      const config = dockConfig[index];
      const label = item.querySelector("span:last-child");

      if (!config || !label) return;

      item.href = config.href;
      label.textContent = config.label;
    });
  };

  const refreshLauncherSection = async () => {
    const launcher = document.querySelector("[data-launcher]");

    if (!launcher || launcher.dataset.sectionRefreshed === "true") {
      applyServiceHomepageFallback();
      setupLauncherMotion();
      setupLauncherPolicies();
      setupLauncherReactiveButtons();
      setupLauncherScrollShadow();
      setupLauncherHeroLens();
      return;
    }

    launcher.dataset.sectionRefreshed = "true";

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=launcher-grid&v=${Date.now()}`,
        {
          credentials: "same-origin",
          redirect: "follow"
        }
      );

      if (!response.ok) {
        throw new Error("Launcher section refresh failed");
      }

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, "text/html");
      const incomingLauncher = parsed.querySelector("[data-launcher]");

      if (incomingLauncher?.querySelector("[data-launcher-tile]")) {
        launcher.replaceWith(incomingLauncher);
      }
    } catch (_error) {
      /* Fall back to the server-rendered launcher when section refresh fails. */
    } finally {
      applyServiceHomepageFallback();
      setupLauncherMotion();
      setupLauncherPolicies();
      setupLauncherReactiveButtons();
      setupLauncherScrollShadow();
      setupLauncherHeroLens();
    }
  };

  void refreshLauncherSection();
})();
